import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const FactoryContainer = (({ theme, $showQuote }) => ({
    padding: $showQuote ? '40px 20px 40px 40px' : "40px 20px",

    [theme.breakpoint.xl()]: {
        padding: "44px calc((100% - 1260px)/2) 64px"
    },

    "@media (min-width: 1200px) and (max-width: 1600px)": {
        padding: "44px 156px 64px 220px"
    },
}));

export const FactoryTitle = (({ theme }) => ({
    fontSize: "36px",
    fontWeight: "700",
    lineHeight: "150%",
    marginBottom: "32px",
    color: theme.color.brandPrimary.light,

    [theme.breakpoint.lg()]: {
        fontSize: "48px"
    }
}));

export const FactoryParagraph = (({ theme }) => ({
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "160%",
    marginBottom: "32px",

    [theme.breakpoint.lg()]: {
        fontSize: "20px"
    }
}))

export const Container = styled.section(({ theme, $showQuote }) => ({
    ...FactoryContainer({ theme, $showQuote }),
    position: 'relative',
}));

export const Title = styled(Text)(({ theme }) => ({
    ...FactoryTitle({ theme })
}));

export const Paragraph = styled(Text)(({ theme }) => ({
    ...FactoryParagraph({ theme }),
    marginBottom: 0
}));

export const Quote = styled.div(({ theme }) => ({
    position: 'absolute',
    top: "17px",
    left: "20px",

    [theme.breakpoint.lg()]: {
        left: "0",
    },

    [theme.breakpoint.xl()]: {
        paddingLeft: "calc((100% - 1290px)/2)"
    },

    "@media (min-width: 1200px) and (max-width: 1600px)": {
        paddingLeft: "200px"
    },
}))

export const Author = styled(Text)(({ theme }) => ({
    ...FactoryParagraph({ theme }),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    textAlign: 'right',
    marginTop: "24px",
    marginBottom: 0,

    span: {
        fontSize: "12px",

        [theme.breakpoint.lg()]: {
            fontSize: "14px"
        }
    }
}));